const DEFAULT_LANGUAGE = 'en-gb';

const LANGUAGE_MAPPING = {
  'en-gb': 'en',
  'th-th': 'th',
  'id-id': 'id',
  'zh-cn': 'zh_CN',
  'zh-tw': 'zh_TW',
  'zh-hk': 'zh_CN',
  'ja-jp': 'ja',
  'ko-kr': 'ko',
  'ms-my': 'en_MY',
  'vi-vn': 'vi',
};

export const TRIP_ADVISOR = {
  DEFAULT_LANGUAGE,
  LANGUAGE_MAPPING,
};
